// extracted by mini-css-extract-plugin
export var container = "Intro-module--container--0d93b";
export var content = "Intro-module--content--4bc31";
export var fadeInAnimation = "Intro-module--fadeInAnimation--7020a";
export var icon = "Intro-module--icon--7be7e";
export var iconImg = "Intro-module--iconImg--34174";
export var iconWrapper = "Intro-module--iconWrapper--dea28";
export var icons = "Intro-module--icons--61731";
export var iconsLayout = "Intro-module--iconsLayout--3cfc9";
export var intro = "Intro-module--intro--a1edd";
export var introWrapper = "Intro-module--introWrapper--993fa";
export var layout = "Intro-module--layout--ca019";
export var link = "Intro-module--link--46a8e";
export var logo = "Intro-module--logo--26f2f";
export var logoWrapper = "Intro-module--logoWrapper--5313c";
export var logos = "Intro-module--logos--2c1e9";
export var picture = "Intro-module--picture--e32ff";
export var pictureImage = "Intro-module--pictureImage--733b3";
export var title = "Intro-module--title--0c3de";